export const reduceProjectContent = (project: any): any => {
    const { variants, papers, sizes, upsells, ...rest } = project;
    return { ...rest };
};